import ClipLoader from "react-spinners/ClipLoader";

import styles from "./AppLoader.module.scss";

const AppLoader = () => {
  return (
    <div className={styles.loader}>
      <ClipLoader size={50} color="#fb3973" />
    </div>
  );
};

export default AppLoader;
